import { render } from "./delayBlock.vue?vue&type=template&id=ed56f650"
import script from "./delayBlock.vue?vue&type=script&lang=js"
export * from "./delayBlock.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__